<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-headers">
      <h3>{{ $i18n.t("Loan & Finance Details") }}</h3>
    </v-btn>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Bank Name')"
          v-model="vehicle.vehicleDetail.loan.bank.bank"
          maxlength="50"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Account No.')"
          v-model="vehicle.vehicleDetail.loan.bank.accountNo"
          maxlength="25"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-date-picker
          :label="$i18n.t('Loan Date')"
          v-model="vehicle.vehicleDetail.loan.loanDate"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <z-date-picker
          :label="$i18n.t('Loan Closing Date')"
          v-model="vehicle.vehicleDetail.loan.loanClosingDate"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Loan Amount')"
          v-model="vehicle.vehicleDetail.loan.amount"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('EMI')"
          v-model="vehicle.vehicleDetail.loan.emi"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="5"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('Total EMIs')"
          v-model="vehicle.vehicleDetail.loan.totalEMIs"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('EMI Paid')"
          v-model="vehicle.vehicleDetail.loan.emiPaid"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="5"
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field
          :label="$i18n.t('IFSC Code')"
          v-model="vehicle.vehicleDetail.loan.bank.ifsc"
          maxlength="20"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="6">
        <v-text-field
          :label="$i18n.t('Bank Address')"
          v-model="vehicle.vehicleDetail.loan.bank.address.addressLine"
          maxlength="50"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Finance",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Finance extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.loan) this.vehicle.vehicleDetail.loan = {};
    if (!this.vehicle.vehicleDetail.loan.bank)
      this.vehicle.vehicleDetail.loan.bank = {};
    if (!this.vehicle.vehicleDetail.loan.bank.address)
      this.vehicle.vehicleDetail.loan.bank.address = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>